import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { AuthService } from '../../../../../../services/auth.services'
import { RestServices } from '../../../../../../services/rest.services'
import { ModalService } from '../../../../../../services/modal.service'
import { SharedServices } from '../../../../../../services/shared.services'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { getImageRedirectUrl } from '../../../../../../../helper/common'
import { MatrixServices } from '../../../../../../services/image/matrix.services'
import { StateServices } from '../../../../../../services/state.services'
import * as $ from 'jquery'

@Component({
    selector: 'app-modal-client-detail-top-registraion-face',
    templateUrl: './modal-client-detail-registraion-face.component.html',
    styleUrls: [
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
        './modal-client-detail-registraion-face.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
    ],
})
export class ModalClientDetailRegistraionFaceComponent implements OnInit, OnDestroy {
    en = {}
    showEN = true
    option_RegistrationFace: String = 'active'
    TabRegistrationFaceClass

    arrTabRegistrationFace = [
        { id: 0, name: 'All', nameSave: 'Registration-Face-All' },
        { id: 1, name: 'Front Smile', nameSave: 'Registration-Face-Front-Smile' },
        { id: 2, name: 'Front Normal', nameSave: 'Registration-Face-Front-Normal' },
        { id: 3, name: 'Side Smile', nameSave: 'Registration-Face-Side-Smile' },
        { id: 4, name: 'Side Normal', nameSave: 'Registration-Face-Side-Normal' },
        { id: 5, name: 'Other 1', nameSave: 'Registration-Face-Other-1' },
        { id: 6, name: 'Other 2', nameSave: 'Registration-Face-Other 2' },
    ]

    statusImage: String = ''
    url: String = ''
    arrRegistrationFace: any[] = []
    status: Boolean = false
    option_Registration: String = 'active'
    senMax: any = 100
    max: any = 5

    arrAllFace: any[] = []
    jsonFace: any = {}
    index: any
    arrShowStatus: any[] = []
    uploadImageForm: FormGroup
    tabName: any = 'face-all'
    width: any
    height: any
    imageAddHeight: any
    imageAddWidth: any
    valChange: any = 0
    arrLoading: any[] = []
    matrixImage: any[] = []
    arrImage: any[] = []
    emitTabName: any = {}
    emitArrAll: any = {}
    animationDuration: any

    arrStyle: any[] = [{}, {}, {}, {}, {}, {}]
    isEmptyArray: Boolean = false
    resourceUrl = 'resource'
    countRecrond
    tabUploadImage: any
    ValueAssignOneDistance: any = 0
    @ViewChild('imageWrapper') imageWrapper: ElementRef
    @ViewChild('imageId') imageId: ElementRef
    oldHeight: any
    oldWidth: any

    defaultArrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrayTypeImage: any[] = ['large', 'large', 'large', 'large', 'large', 'large']
    arrIds: any[] = []
    arrStyleImage = []
    unscrCopy
    unscrIndex
    unscrAllArrClientTop
    unscrArrHash
    getInfoIndex = undefined

    page = 'registration'
    unscrPage

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private modalService: ModalService,
                private clientTopServices: ClientTopServices,
                public matrixServices: MatrixServices,
                private stateServices: StateServices) {
        this.option_RegistrationFace = 'active'
        this.TabRegistrationFaceClass = 'option_0'
    }

    ngOnInit() {
        this.resetMatrix()
        this.arrLoading = [true, true, true, true, true, true]
        this.uploadImageForm = this.formBuider.group({
            requests: new FormArray([
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
                new FormControl(null),
            ]),
        })
        // this.clientTopServices.changeEmittedTabName$.subscribe(infoTabName => {
        const infoTabName: any = this.clientTopServices.functReturnTabName()
        if (infoTabName != null && infoTabName['tabName'] != undefined) {
            this.tabName = infoTabName['tabName']
        } else {
            this.tabName = 'face-all'
        }
        const tmpStr: String = this.tabName
        if (tmpStr.includes('face')) {
            // this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrAll => {
            this.getArrClientTop()
            // });
        }
        // });

        this.clientTopServices.changeEmittedStatus$.subscribe(res => {
            if (res != null && res['status'] != undefined) {
                this.status = res['status']
            } else {
                this.status = false
            }
        })
        if ($(window).innerWidth() != window.screen.width) {
            this.width = ($(window).innerWidth() - 300) / 3
            this.height = 2 * this.width / 3
        } else if ($(window).innerHeight() != window.screen.height) {
            const tmpH = $(window).innerHeight()
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
        this.imageAddHeight = this.height / 6
        this.imageAddWidth = this.width / 6
        this.getArrHash()
        this.getStyle()
        this.resizeUser()
        this.resizeFullScreen()
        this.getPage()
    }

    ngOnDestroy() {
        this.getInfoIndex = undefined
        if(this.unscrPage)
            this.unscrPage.unsubscribe()
        if(this.unscrIndex)
            this.unscrIndex.unsubscribe()
        if(this.unscrAllArrClientTop)
            this.unscrAllArrClientTop.unsubscribe()
        if(this.unscrArrHash)
            this.unscrArrHash.unsubscribe()
    }

    getPage() {
        this.unscrPage = this.clientTopServices.changeEmiitedPage$.subscribe(res => {
            if (res) {
                this.page = res
            }
        })
    }

    resizeFullScreen() {
        this.clientTopServices.changeEmitted$.subscribe(screen => {
            if (screen != null && screen != undefined && screen['status'] != undefined) {
                if (screen['status'] == 'active') {
                    this.height = this.oldHeight
                    this.width = this.oldWidth
                } else if (screen['status'] == 'hidden') {
                    if ($(window).innerWidth() != window.screen.width) {
                        const tmpW = $(window).innerWidth()
                        this.width = (tmpW - 200) / 3
                        this.height = this.width * 2 / 3
                    } else if ($(window).innerHeight() != window.screen.height) {
                        const tmpH = $(window).innerHeight()
                        this.height = (tmpH - 200) / 2
                        this.width = this.height * 3 / 2
                    }
                }
                const _thi = this
                setTimeout(function() {
                    _thi.arrShowStatus.forEach((el, item) => {
                        if (el) {
                            const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                            const imageId: HTMLElement = document.getElementById('imageId' + item)
                            _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationFace)
                        }
                    })
                }, 10)
            }
        })
    }

    resetMatrix() {
        this.matrixServices.arrRotate = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrStyleImage = [0, 0, 0, 0, 0, 0]
        this.matrixServices.arrFlip = [
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
            {
                'horizontalFlip': 1,
                'verticalFlip': 1,
            },
        ]
    }

    resizeUser() {
        this.clientTopServices.changeEmittedViewDetailUser$.subscribe(status => {
            const tmpStr: String = this.tabName
            if (tmpStr.includes('face')) {
                if (status != null && status['status'] != undefined) {
                    this.resetMatrix()
                    const tmp: any = status['status']
                    if (tmp == 'in') {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        } else {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 500) / 2
                            this.width = this.height * 3 / 2
                        }
                    } else {
                        if ($(window).innerWidth() != window.screen.width) {
                            const tmpW = $(window).innerWidth()
                            this.width = (tmpW - 300) / 3
                            this.height = this.width * 2 / 3
                        } else if ($(window).innerHeight() != window.screen.height) {
                            const tmpH = $(window).innerHeight()
                            this.height = (tmpH - 300) / 2
                            this.width = this.height * 3 / 2
                        }
                    }
                    this.oldHeight = this.height
                    this.oldWidth = this.width
                    const _thi = this
                    setTimeout(function() {
                        _thi.arrShowStatus.forEach((el, item) => {
                            if (el) {
                                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                                const imageId: HTMLElement = document.getElementById('imageId' + item)
                                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationFace)
                            }
                        })
                    }, 10)
                }
            }
        })
    }

    resetMatrixMovedUpPage() {
        const _thi = this
        setTimeout(function() {
            _thi.arrShowStatus.forEach((el, item) => {
                if (el) {
                    const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                    const imageId: HTMLElement = document.getElementById('imageId' + item)
                    if (imageId != undefined && imageWrapper != undefined) {
                        _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, _thi.matrixImage, _thi.arrImage, _thi.arrRegistrationFace)
                    }
                }
            })
        }, 10)
    }

    getArrClientTop() {
        this.getDataShow()
        this.getDataIndex()
    }

    getDataIndex() {
        this.unscrIndex = this.clientTopServices.changeEmittedIndex$.subscribe(infoIndex => {
            const tmpStr: String = this.tabName
            if (infoIndex != null && infoIndex['index'] != undefined && this.page == 'registration') {
                this.index = infoIndex['index']
                this.getInfoIndex = jQuery.extend(true, {}, infoIndex)
                if (tmpStr.includes('face') && this.arrAllFace.length > 0) {
                    this.max = this.arrAllFace.length - 1
                    if (this.max > 0) {
                        this.ValueAssignOneDistance = this.senMax / this.max
                        this.valChange = this.index * this.ValueAssignOneDistance
                    } else {
                        this.valChange = 0
                    }
                    this.arrLoading = [false, false, false, false, false, false]
                    if (this.arrAllFace[this.index] != undefined) {
                        this.jsonFace = this.arrAllFace[this.index]
                        this.initjsonFace(this.arrAllFace[this.index])
                    }
                }
            }
        })
    }

    getDataShow() {
        this.unscrAllArrClientTop = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(res => {
            const tmpStr: String = this.tabName
            if (res != null && res['registration'] != undefined && res['registration'].length > 0 && this.page == 'registration') {
                this.isEmptyArray = false
                this.arrAllFace = res['registration']
                this.countRecrond = res['registration'].length
                if (tmpStr.includes('face') && this.getInfoIndex) {
                    if (this.arrAllFace.length > 0) {
                        this.max = this.arrAllFace.length - 1
                        if (this.max > 0) {
                            this.ValueAssignOneDistance = this.senMax / this.max
                            this.valChange = this.index * this.ValueAssignOneDistance
                        } else {
                            this.valChange = 0
                        }

                        if (this.arrAllFace[this.index] != undefined) {
                            this.jsonFace = this.arrAllFace[this.index]
                            this.initjsonFace(this.arrAllFace[this.index])
                            this.animationDuration = 300
                        }
                    }
                }
            } else {
                this.countRecrond = 0
                this.isEmptyArray = true
                this.arrRegistrationFace = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                this.getShowStatus(this.arrRegistrationFace)
            }
        })
    }

    // isEmptyArr() {
    //   this.clientTopServices.changeEmiitedIsCreated$.subscribe(create => {
    //     if (create != null && create['create'] != undefined) {
    //       const tab: any = create['tabName'];
    //       if (tab == this.tabName) {
    //         this.isEmptyArray = true;
    //         this.getArrClientTop();
    //       }
    //     }
    //   });
    // }

    // refresh() {
    //   this.clientTopServices.changeEmittedrefreshArr$.subscribe(refresh => {
    //     if (refresh != null && refresh['refresh'] != undefined) {
    //       const tab: any = refresh['tabName'];
    //       if (refresh['refresh'] == true && this.tabName == tab) {
    //         this.callApiInfoTopClient();
    //       }
    //     }
    //   });
    // }

    getArrCopy() {
        this.unscrCopy = this.clientTopServices.changeEmittedArrCopy$.subscribe(arCopy => {
            if (arCopy != null && arCopy['onCut'] != undefined) {
                if (arCopy['onCut'] == 'cut') {
                    const tab = arCopy['tabName']
                    if (this.tabName == tab) {
                        this.arrRegistrationFace = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                        this.getShowStatus(this.arrRegistrationFace)
                        this.jsonFace[this.tabName] = this.arrRegistrationFace
                        this.arrAllFace[this.index] = this.jsonFace
                        const arrCopy: any[] = arCopy['arrCopy']
                        const tmp: any = arrCopy[0]['id'] ? arrCopy[0]['id'] : ''
                        const jsonTmp: any = {}
                        jsonTmp['id'] = tmp
                        if (arrCopy[0]['id'] != '') {
                            switch (this.tabName) {
                                case 'face-1':
                                    if (tmp != '') {
                                        this.jsonFace['face-all'][0] = jsonTmp
                                    }
                                    break
                                case 'face-2':
                                    if (tmp != '') {
                                        this.jsonFace['face-all'][1] = jsonTmp
                                    }
                                    break
                                case 'face-3':
                                    if (tmp != '') {
                                        this.jsonFace['face-all'][2] = jsonTmp
                                    }
                                    break
                                case 'face-4':
                                    if (tmp != '') {
                                        this.jsonFace['face-all'][3] = jsonTmp
                                    }
                                    break
                                case 'face-5':
                                    if (tmp != '') {
                                        this.jsonFace['face-all'][4] = jsonTmp
                                    }
                                    break
                                case 'face-6':
                                    if (tmp != '') {
                                        this.jsonFace['face-all'][5] = jsonTmp
                                    }
                                    break
                                case 'face-all':
                                    arrCopy.forEach((el, i) => {
                                        switch (i) {
                                            case 0:
                                                this.jsonFace['face-1'][0] = jsonTmp
                                                break
                                            case 1:
                                                this.jsonFace['face-2'][0] = jsonTmp
                                                break
                                            case 2:
                                                this.jsonFace['face-3'][0] = jsonTmp
                                                break
                                            case 3:
                                                this.jsonFace['face-4'][0] = jsonTmp
                                                break
                                            case 4:
                                                this.jsonFace['face-5'][0] = jsonTmp
                                                break
                                            case 5:
                                                this.jsonFace['face-6'][0] = jsonTmp
                                                break
                                            default:
                                                break
                                        }
                                    })
                                    break
                                default:
                                    break
                            }
                            this.arrAllFace[this.index] = this.jsonFace
                        }
                    }
                }
            }
        })
    }

    getStyle() {
        this.clientTopServices.changeEmittedStyle$.subscribe(style => {
            if (style != null && style['style'] != undefined) {
                const tab: any = style['tabName']
                if (tab == this.tabName) {
                    this.arrStyle = style['style']
                    if (this.arrStyle.length > 0) {
                        this.arrRegistrationFace = [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
                        this.getShowStatus(this.arrRegistrationFace)
                        this.jsonFace[this.tabName] = this.arrRegistrationFace
                        this.arrAllFace[this.index] = this.jsonFace
                        this.emitArrAll['registration'] = this.arrAllFace
                        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                    } else {
                        const arrCopy: any[] = style['arrCopy']
                        this.arrRegistrationFace = arrCopy
                        this.getShowStatus(this.arrRegistrationFace)
                        this.jsonFace[this.tabName] = this.arrRegistrationFace
                        this.arrAllFace[this.index] = this.jsonFace
                    }
                }
            } else {
                this.arrStyle = [{}, {}, {}, {}, {}, {}]
            }
        })
    }

    getArrHash() {
        this.unscrArrHash = this.stateServices.changeEmittedHash$.subscribe(response => {
            if (response != null && response[this.tabName] != undefined && response[this.tabName].length > 0) {
                const tmpStr: String = this.tabName
                const arrRes: any[] = response[this.tabName]
                if (tmpStr.includes('face')) {
                    this.arrRegistrationFace = jQuery.extend(true, [], arrRes)
                    // arrRes.forEach((el, i) => {
                    //     this.arrRegistrationFace[i] = el;
                    // });
                    this.jsonFace[this.tabName] = this.arrRegistrationFace
                    this.arrAllFace[this.index] = this.jsonFace
                    const tmp: any = arrRes[0]
                    switch (this.tabName) {
                        case 'face-1':
                            this.arrAllFace[this.index]['face-all'][0] = tmp
                            break
                        case 'face-2':
                            this.arrAllFace[this.index]['face-all'][1] = tmp
                            break
                        case 'face-3':
                            this.arrAllFace[this.index]['face-all'][2] = tmp
                            break
                        case 'face-4':
                            this.arrAllFace[this.index]['face-all'][3] = tmp
                            break
                        case 'face-5':
                            this.arrAllFace[this.index]['face-all'][4] = tmp
                            break
                        case 'face-6':
                            this.arrAllFace[this.index]['face-all'][5] = tmp
                            break
                        case 'face-all':
                            arrRes.forEach((el, i) => {
                                const count = i + 1
                                const tabN = 'face-' + count
                                this.arrAllFace[this.index][tabN][0] = el
                            })
                            break
                        default:
                            break
                    }
                    this.emitArrAll['registration'] = this.arrAllFace
                    this.emitArrAll['checkChange'] = true
                    this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
                }
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (event.target.innerWidth != window.screen.width) {
            const tmpW = event.target.innerWidth
            this.width = (tmpW - 300) / 3
            this.height = this.width * 2 / 3
        } else if (event.target.innerHeight != window.screen.height) {
            const tmpH = event.target.innerHeight
            this.height = (tmpH - 300) / 2
            this.width = this.height * 3 / 2
        }
        this.oldHeight = this.height
        this.oldWidth = this.width
    }

    showBigImage(id, matrix) {
        const emitArr: any = {}
        emitArr['id'] = id
        emitArr['showBigImage'] = true
        emitArr['matrix'] = matrix
        this.clientTopServices.emitChange(emitArr)
    }

    changeValueEx1SliderRegister(valueUsageChange) {
        const value: any = valueUsageChange
        if (this.max > 0) {
            const tmp: number = (value / this.senMax) * this.max
            this.index = Math.round(tmp)
            const tmpEarch: number = this.senMax / this.max
            const assignCalculate = Math.round(tmpEarch)
            const assign = this.index * assignCalculate
            // if (this.arrAllFace[this.index] != undefined) {
            //     this.jsonFace = this.arrAllFace[this.index];
            //     this.initjsonFace(this.jsonFace);
            //     this.arrRegistrationFace = this.jsonFace[this.tabName];
            // }
            // this.valChange = assign;
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = valueUsageChange
            this.clientTopServices.emitChangeSlider(valueSlider)
        } else {
            this.valChange = 0
            const valueSlider: any = {}
            valueSlider['sliderClientTop'] = 0
            this.clientTopServices.emitChangeSlider(valueSlider)
        }
    }

    initjsonFace(json) {
        this.jsonFace['face-1'] = (json['face-1'] != undefined) ? json['face-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-2'] = (json['face-2'] != undefined) ? json['face-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-3'] = (json['face-3'] != undefined) ? json['face-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-4'] = (json['face-4'] != undefined) ? json['face-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-5'] = (json['face-5'] != undefined) ? json['face-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-6'] = (json['face-6'] != undefined) ? json['face-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['face-all'] = (json['face-all'] != undefined) ? json['face-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonFace['other-1'] = (json['other-1'] != undefined) ? json['other-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-2'] = (json['other-2'] != undefined) ? json['other-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-3'] = (json['other-3'] != undefined) ? json['other-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-4'] = (json['other-4'] != undefined) ? json['other-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-5'] = (json['other-5'] != undefined) ? json['other-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-6'] = (json['other-6'] != undefined) ? json['other-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['other-all'] = (json['other-all'] != undefined) ? json['other-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonFace['movie-1'] = (json['movie-1'] != undefined) ? json['movie-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-2'] = (json['movie-2'] != undefined) ? json['movie-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-3'] = (json['movie-3'] != undefined) ? json['movie-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-4'] = (json['movie-4'] != undefined) ? json['movie-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-5'] = (json['movie-5'] != undefined) ? json['movie-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-6'] = (json['movie-6'] != undefined) ? json['movie-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['movie-all'] = (json['movie-all'] != undefined) ? json['movie-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonFace['xp-1'] = (json['xp-1'] != undefined) ? json['xp-1'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-2'] = (json['xp-2'] != undefined) ? json['xp-2'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-3'] = (json['xp-3'] != undefined) ? json['xp-3'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-4'] = (json['xp-4'] != undefined) ? json['xp-4'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-5'] = (json['xp-5'] != undefined) ? json['xp-5'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-6'] = (json['xp-6'] != undefined) ? json['xp-6'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['xp-all'] = (json['xp-all'] != undefined) ? json['xp-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonFace['tooth-right'] = (json['tooth-right'] != undefined) ? json['tooth-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-front'] = (json['tooth-front'] != undefined) ? json['tooth-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-left'] = (json['tooth-left'] != undefined) ? json['tooth-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-upper'] = (json['tooth-upper'] != undefined) ? json['tooth-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-overjet'] = (json['tooth-overjet'] != undefined) ? json['tooth-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-lower'] = (json['tooth-lower'] != undefined) ? json['tooth-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['tooth-all'] = (json['tooth-all'] != undefined) ? json['tooth-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]

        this.jsonFace['aligner-right'] = (json['aligner-right'] != undefined) ? json['aligner-right'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-front'] = (json['aligner-front'] != undefined) ? json['aligner-front'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-left'] = (json['aligner-left'] != undefined) ? json['aligner-left'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-upper'] = (json['aligner-upper'] != undefined) ? json['aligner-upper'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-overjet'] = (json['aligner-overjet'] != undefined) ? json['aligner-overjet'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-lower'] = (json['aligner-lower'] != undefined) ? json['aligner-lower'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.jsonFace['aligner-all'] = (json['aligner-all'] != undefined) ? json['aligner-all'] : [{ id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }, { id: '' }]
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.getArrRegistrationFace(this.jsonFace)
    }

    getArrRegistrationFace(arrTooth) {
        this.arrRegistrationFace = arrTooth[this.tabName]
        this.getShowStatus(this.arrRegistrationFace)
    }

    onDeleteImage(index) {
        this.matrixServices.removePhoto(index)
        const tmpNone: any = {}
        tmpNone['id'] = ''
        this.arrRegistrationFace[index] = tmpNone
        switch (this.TabRegistrationFaceClass) {
            case 'option_0':
                this.jsonFace['face-all'] = this.arrRegistrationFace
                const countIndex = index + 1
                const i: any = 'face-' + countIndex
                const tmp: any = {}
                tmp['id'] = ''
                this.jsonFace[i][0] = tmp
                break
            case 'option_1':
                if (index == 0) {
                    const tmp1: any = {}
                    tmp1['id'] = ''
                    this.jsonFace['face-all'][0] = tmp1
                }
                this.jsonFace['face-1'] = this.arrRegistrationFace
                break
            case 'option_2':
                if (index == 0) {
                    const tmp2: any = {}
                    tmp2['id'] = ''
                    this.jsonFace['face-all'][1] = tmp2
                }
                this.jsonFace['face-2'] = this.arrRegistrationFace
                break
            case 'option_3':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonFace['face-all'][2] = tmp3
                }
                this.jsonFace['face-3'] = this.arrRegistrationFace
                break
            case 'option_4':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonFace['face-all'][3] = tmp3
                }
                this.jsonFace['face-4'] = this.arrRegistrationFace
                break
            case 'option_5':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonFace['face-all'][4] = tmp3
                }
                this.jsonFace['face-5'] = this.arrRegistrationFace
                break
            case 'option_6':
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonFace['face-all'][5] = tmp3
                }
                this.jsonFace['face-6'] = this.arrRegistrationFace
                break
            default:
                break
        }
        this.uploadImageForm.reset()
        this.matrixServices.removePhoto(index)
        this.arrAllFace[this.index] = this.jsonFace
        this.emitArrAll['registration'] = this.arrAllFace
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationFace)
    }

    swapMatrix(index, nextIndex) {
        const tmp = this.matrixImage[index]
        const swapTmp = this.matrixImage[nextIndex]
        this.matrixImage[index] = swapTmp
        this.matrixImage[nextIndex] = tmp
    }

    swapArrImage(index, nextIndex) {
        const tmp = this.arrImage[index]
        const swapTmp = this.arrImage[nextIndex]
        this.arrImage[index] = swapTmp
        this.arrImage[nextIndex] = tmp
    }

    swapArrImageStyle(index, nextIndex) {
        const tmp = this.arrStyleImage[index]
        const swapTmp = this.arrStyleImage[nextIndex]
        this.arrStyleImage[index] = swapTmp
        this.arrStyleImage[nextIndex] = tmp
    }

    swapArr(index, nextIndex) {
        this.swapMatrix(index, nextIndex)
        this.swapArrImage(index, nextIndex)
        this.swapArrImageStyle(index, nextIndex)
        const tmp = this.arrRegistrationFace[index]
        const tmpRight = this.arrRegistrationFace[nextIndex]
        this.arrRegistrationFace[index] = tmpRight
        this.arrRegistrationFace[nextIndex] = tmp
        switch (this.TabRegistrationFaceClass) {
            case 'option_0':
                this.jsonFace['face-all'] = this.arrRegistrationFace
                let i: any
                let left: any
                let right: any
                const countIndex = index + 1
                switch (countIndex) {
                    case 1:
                        i = 'face-1'
                        right = 'face-2'
                        break
                    case 2:
                        left = 'face-1'
                        i = 'face-2'
                        right = 'face-3'
                        break
                    case 3:
                        left = 'face-2'
                        i = 'face-3'
                        right = 'face-4'
                        break
                    case 4:
                        left = 'face-3'
                        i = 'face-4'
                        right = 'face-5'
                        break
                    case 5:
                        left = 'face-4'
                        i = 'face-5'
                        right = 'face-6'
                        break
                    case 6:
                        left = 'face-5'
                        i = 'face-6'
                        break
                }
                if (index > nextIndex) {
                    this.jsonFace[left][0] = tmp
                    this.jsonFace[i][0] = tmpRight
                } else {
                    this.jsonFace[i][0] = tmpRight
                    this.jsonFace[right][0] = tmp
                }
                break
            case 'option_1':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonFace['face-all'][0] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonFace['face-all'][0] = tmp3
                }
                this.jsonFace['face-1'] = this.arrRegistrationFace
                break
            case 'option_2':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonFace['face-all'][1] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonFace['face-all'][1] = tmp3
                }
                this.jsonFace['face-2'] = this.arrRegistrationFace
                break
            case 'option_3':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonFace['face-all'][2] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonFace['face-all'][2] = tmp3
                }
                this.jsonFace['face-3'] = this.arrRegistrationFace
                break
            case 'option_4':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonFace['face-all'][3] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonFace['face-all'][3] = tmp3
                }
                this.jsonFace['face-4'] = this.arrRegistrationFace
                break
            case 'option_5':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonFace['face-all'][4] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonFace['face-all'][4] = tmp3
                }
                this.jsonFace['face-5'] = this.arrRegistrationFace
                break
            case 'option_6':
                if (index > nextIndex) {
                    if (nextIndex == 0) {
                        this.jsonFace['face-all'][5] = tmp
                    }
                }
                if (index == 0) {
                    const tmp3: any = {}
                    tmp3['id'] = ''
                    this.jsonFace['face-all'][5] = tmp3
                }
                this.jsonFace['face-6'] = this.arrRegistrationFace
                break
            default:
                break
        }
        this.arrAllFace[this.index] = this.jsonFace
        this.emitArrAll['registration'] = this.arrAllFace
        this.emitArrAll['checkChange'] = true
        this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        this.getShowStatus(this.arrRegistrationFace)
    }

    moveRight(index) {
        const nextIndex: any = index + 1
        this.swapArr(index, nextIndex)
    }

    moveLeft(index) {
        const nextIndex: any = index - 1
        this.swapArr(index, nextIndex)
    }

    getShowStatus(arr: any[] = []) {
        this.arrShowStatus = []
        this.matrixImage = []
        this.arrImage = []
        this.arrStyleImage = []
        if (arr && arr.length > 0) {
            arr.forEach((el, i) => {
                if (el != undefined && el['id'] != undefined && el['id'] != '') {
                    let url
                    if (this.arrayTypeImage[i] != 'other') {
                        url = getImageRedirectUrl(el['id'] + '?type=' + this.arrayTypeImage[i])
                    } else {
                        url = getImageRedirectUrl(el['id'])
                    }
                    this.arrIds[i] = el['id']
                    this.arrImage.push(url)
                    this.arrShowStatus.push(true)
                } else {
                    this.arrImage.push(undefined)
                    this.arrShowStatus.push(false)
                }
                if (el != undefined && el['matrix'] != undefined) {
                    this.matrixImage.push(el['matrix'])
                } else {
                    this.matrixImage.push([1, 0, 0, 1])
                }
                if (el != undefined && el['style'] != undefined) {
                    this.arrStyleImage.push(el['style'])
                } else {
                    this.arrStyleImage.push({})
                }
            })
        }
        this.getStyleMatrix(this.matrixImage, this.arrImage, this.arrRegistrationFace)
        // this.resetMatrixMovedUpPage();
    }

    getStyleMatrix(matrixImage, arrImage, arrRegistration) {
        const _thi = this
        setTimeout(() => {
            arrRegistration.forEach(function(el, item) {
                const imageWrapper: HTMLElement = document.getElementById('imageWrapper' + item)
                const imageId: HTMLElement = document.getElementById('imageId' + item)
                _thi.matrixServices.loadSizeImage(imageId, imageWrapper, item, matrixImage, arrImage, arrRegistration)
            })
        }, 200)
    }

    toggleTabRegistrationFaceItem(id, index, event) {
        this.uploadImageForm.reset()
        this.TabRegistrationFaceClass = id
        switch (id) {
            case 'option_0':
                this.tabName = 'face-all'
                break
            case 'option_1':
                this.tabName = 'face-1'
                break
            case 'option_2':
                this.tabName = 'face-2'
                break
            case 'option_3':
                this.tabName = 'face-3'
                break
            case 'option_4':
                this.tabName = 'face-4'
                break
            case 'option_5':
                this.tabName = 'face-5'
                break
            case 'option_6':
                this.tabName = 'face-6'
                break
            default:
                this.tabName = 'face-all'
                break
        }
        this.arrayTypeImage = jQuery.extend(true, [], this.defaultArrayTypeImage)
        this.emitTabName['tabName'] = this.tabName
        this.arrRegistrationFace = this.jsonFace[this.tabName]
        this.tabUploadImage = undefined
        this.clientTopServices.emitChangeTabName(this.emitTabName)
        this.getShowStatus(this.arrRegistrationFace)
    }

    getUrlImage(item, url) {
        if (url == '') {
            if (undefined != this.arrRegistrationFace && this.arrRegistrationFace.length > 0) {
                const tmp: any = this.arrRegistrationFace[item]
                if (tmp != undefined && tmp['id'] != '') {
                    return getImageRedirectUrl(tmp['id'])
                }
            }
            return ''
        } else {
            return url
        }
    }

    setArrClientTop(data, index, idImage) {
        this.arrRegistrationFace = data
        this.getShowStatus(this.arrRegistrationFace)
        if (this.tabUploadImage != undefined) {
            switch (this.tabUploadImage) {
                case 'option_0':
                    this.jsonFace['face-all'] = data
                    const countIndex = index + 1
                    const i: any = 'face-' + countIndex
                    const tmp: any = idImage
                    this.jsonFace[i][0] = tmp
                    break
                case 'option_1':
                    this.jsonFace['face-1'] = data
                    if (index == 0) {
                        const tmp3: any = idImage
                        this.jsonFace['face-all'][0] = tmp3
                    }
                    break
                case 'option_2':
                    if (index == 0) {
                        const tmp3: any = idImage
                        this.jsonFace['face-all'][1] = tmp3
                    }
                    this.jsonFace['face-2'] = data
                    break
                case 'option_3':
                    if (index == 0) {
                        const tmp3: any = idImage
                        this.jsonFace['face-all'][2] = tmp3
                    }
                    this.jsonFace['face-3'] = data
                    break
                case 'option_4':
                    if (index == 0) {
                        const tmp3: any = idImage
                        this.jsonFace['face-all'][3] = tmp3
                    }
                    this.jsonFace['face-4'] = data
                    break
                case 'option_5':
                    if (index == 0) {
                        const tmp3: any = idImage
                        this.jsonFace['face-all'][4] = tmp3
                    }
                    this.jsonFace['face-5'] = data
                    break
                case 'option_6':
                    if (index == 0) {
                        const tmp3: any = idImage
                        this.jsonFace['face-all'][5] = tmp3
                    }
                    this.jsonFace['face-6'] = data
                    break
                default:
                    break
            }
            this.arrAllFace[this.index] = this.jsonFace
            this.emitArrAll['registration'] = this.arrAllFace
            this.emitArrAll['checkChange'] = true
            this.clientTopServices.emitChangeAllArrClientTop(this.emitArrAll)
        }
    }

    uploadFileEnd(event) {
        this.tabUploadImage = this.TabRegistrationFaceClass
        this.clientTopServices.checkChangeData = true
        const jsonFlip: any = {
            'horizontalFlip': 1,
            'verticalFlip': 1,
        }
        const i = event.item
        this.matrixServices.arrFlip[i] = jsonFlip
        const tmp: any = {}
        tmp['id'] = event.success['hash']
        tmp['matrix'] = [1, 0, 0, 1]
        this.arrRegistrationFace[i] = tmp
        this.matrixImage[i] = [1, 0, 0, 1]
        const url = getImageRedirectUrl(event.success['hash'])
        this.arrImage[i] = url
        this.setArrClientTop(this.arrRegistrationFace, i, tmp)
        this.arrLoading[i] = false
    }

    onUploadError() {
        this.uploadImageForm.reset()
        //Todo notify file error if have
    }

    onStartUpload(event) {
        let listUpload: any[] = event.listUpload
        this.animationDuration = event.animationDuration
        const arrLenghtImageFile = event.arrLenghtImageFile
        for (let index = 0; index < listUpload.length; index++) {
            if (listUpload[index] && arrLenghtImageFile > index) {
                this.arrLoading[listUpload[index]] = true
            }
        }
    }

    handleFileInput(files: FileList, ind, event) {
        if (event.target.files && event.target.files[0]) {
            this.tabUploadImage = this.TabRegistrationFaceClass
            const reader = new FileReader()
            reader.readAsDataURL(event.target.files[0])
            const excrptFile: any = 'image/'
            const tmpFile: any = files[0]
            const typeFile: String = tmpFile['type']
            if (typeFile.includes(excrptFile)) {
                this.animationDuration = 2800
                this.arrLoading[ind] = true
                reader.onload = (event: any) => {
                    this.getUrlImage(this.index, event.target.result)
                    this.url = event.target.result
                    this.arrShowStatus[ind] = true
                }
                const arrUploadImage: any[] = this.arrRegistrationFace
                this.authData.authToken().then(tokenReNew => {
                    this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                        success => {
                            const jsonFlip: any = {
                                'horizontalFlip': 1,
                                'verticalFlip': 1,
                            }
                            this.arrLoading[ind] = false
                            this.matrixServices.arrFlip[ind] = jsonFlip
                            const tmp: any = {}
                            tmp['id'] = success['hash']
                            tmp['matrix'] = [1, 0, 0, 1]
                            arrUploadImage[ind] = tmp
                            this.matrixImage[ind] = [1, 0, 0, 1]
                            const url = getImageRedirectUrl(success['hash'])
                            this.arrImage[ind] = url
                            this.setArrClientTop(arrUploadImage, ind, tmp)
                            this.resetFile(ind)
                        },
                    )
                })
            } else {
                this.uploadImageForm.reset()
            }
        } else {
            this.uploadImageForm.reset()
        }
    }

    resetFile(item) {
        $('#fileUpload_' + item).val('');
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/registration/registrationFace/modal-client-detail-registraion-face.component.ts